import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx, keyframes } from '@emotion/react';
import { R100 } from '@atlaskit/theme/colors';
var pulseBackground = keyframes({
  '50%': {
    backgroundColor: "var(--ds-blanket-danger, ".concat(R100, ")")
  }
});
var pulseBackgroundReverse = keyframes({
  '0%': {
    backgroundColor: "var(--ds-blanket-danger, ".concat(R100, ")")
  },
  '50%': {
    backgroundColor: 'auto'
  },
  '100%': {
    backgroundColor: "var(--ds-blanket-danger, ".concat(R100, ")")
  }
});
var flashWrapper = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.-flash > div': {
    animation: "0.25s ease-in-out ".concat(pulseBackgroundReverse)
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& > div': {
    animation: "'none'"
  }
});
var flashWrapperAnimated = css(_defineProperty({}, "".concat(flashWrapper, " & > div"), {
  animation: "0.25s ease-in-out ".concat(pulseBackground)
}));
var WithFlash = /*#__PURE__*/function (_React$Component) {
  _inherits(WithFlash, _React$Component);
  var _super = _createSuper(WithFlash);
  function WithFlash() {
    var _this;
    _classCallCheck(this, WithFlash);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "toggle", false);
    return _this;
  }
  _createClass(WithFlash, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        animate = _this$props.animate,
        children = _this$props.children;
      this.toggle = animate && !this.toggle;
      return (
        // eslint-disable-next-line @atlaskit/design-system/prefer-primitives
        jsx("div", {
          css: animate ? flashWrapperAnimated : flashWrapper
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
          ,
          className: this.toggle ? '-flash' : ''
        }, children)
      );
    }
  }]);
  return WithFlash;
}(React.Component);
export { WithFlash as default };